import strings from 'owa-strings/owa-options-strings';
export default function getInboxRuleMessageTypeOptions() {
    return [
        { value: 'ApprovalRequest', text: strings.options_inboxRules_requestForApproval },
        { value: 'AutomaticForward', text: strings.options_inboxRules_automaticallyForwarded },
        { value: 'AutomaticReply', text: strings.options_inboxRules_automaticReply },
        { value: 'Calendaring', text: strings.options_inboxRules_invitation },
        { value: 'CalendaringResponse', text: strings.options_inboxRules_eventResponse },
        { value: 'Encrypted', text: strings.options_inboxRules_encrypted },
        { value: 'NonDeliveryReport', text: strings.options_inboxRules_nonDeliveryReport },
        { value: 'PermissionControlled', text: strings.options_inboxRules_permissionControlled },
        { value: 'ReadReceipt', text: strings.options_inboxRules_readReceipt },
        { value: 'Signed', text: strings.options_inboxRules_signed },
        { value: 'Voicemail', text: strings.options_inboxRules_voiceMail },
    ];
}
//# sourceMappingURL=getInboxRuleMessageTypeOptions.js.map